import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import TypedText from "components/Homes/typewrite";
import { getoffsite } from "components/Service/CommIndoffsiteApi";
import { ProjectlistApi } from "components/Service/ProjectApi";

const UUID ="ee8a8dfc-6692-49b6-a20c-c2fce6a51287";

const CIOffsiteProject: React.FC = () => {
    const [data, setData] = useState<any | null>(null);
    const [ProjectList, setDatap] = useState<any[] | null>(null);
    const isDesktop = window.innerWidth >= 992;
const [error, setError] = useState<string | null>(null);
const [retry, setRetry] = useState(0);
    // fetch data
    useEffect(() => {
        getoffsite(UUID).then(setData);
    }, []);

    useEffect(() => {
        const load = async () => {
            try {
            
            const datalist = await ProjectlistApi(); // ✅ call function
            setDatap(datalist);
            setError(null);
            } catch (e: any) {
            setError(e.message || "Failed to load investor data");
        
            // Retry after 10 seconds
            setTimeout(() => {
                setRetry((prev) => prev + 1);
            }, 10000);
            } finally {
            }
        };
        
        load();
    }, [ retry]);
 
   
        
    const filteredProjects = (ProjectList || [])
        .filter(
            (item: any) =>
            item.project_tab === "Commercial & Industrial" && item.status === true
        )
        .sort(
            (a, b) =>
            new Date(b.project_date).getTime() -
            new Date(a.project_date).getTime()
        )
        .slice(0, 3);

const swiperRefs = useRef<any[]>([]);
  const prevRefs = useRef<any[]>([]);
  const nextRefs = useRef<any[]>([]);

  // ✅ separate counters per swiper
  const [activeGroups, setActiveGroups] = useState<any>({});
  const [totalGroups, setTotalGroups] = useState<any>({});

  // ✅ Counter update
  const updateCounter = (swiper: any, index: number) => {
    if (!swiper) return;

    const slidesPerGroup = swiper.params.slidesPerGroup || 1;

    const realSlidesCount = swiper.slides.filter(
      (slide: any) => !slide.classList.contains("swiper-slide-duplicate"),
    ).length;

    const currentGroup = Math.floor(swiper.realIndex / slidesPerGroup) + 1;

    const total = Math.ceil(realSlidesCount / slidesPerGroup);

    setActiveGroups((prev: any) => ({
      ...prev,
      [index]: currentGroup,
    }));

    setTotalGroups((prev: any) => ({
      ...prev,
      [index]: total,
    }));
  };


    //console.log(ProjectList);
    if (!data) return null;
    if(!ProjectList) return null;
    if(data?.buttonLink){
     for (let i = 0; i < data.buttonLink.length; i++) {
        const tab = data.buttonLink[i];
        const cleanPath = tab?.uri.replace("internal:/", "");
      data.buttonLink[i].uri = cleanPath;
      }
    }
return (

    <div id="section-OurProjects" className={`section-OurProjects section-OurProjectsOnsite pt-3 ${data?.status ? "" : "d-none"}`}>
        <div className="container py-3 mb-4">
            <div className="section-title  text-start mx-auto mb-4 wow fadeInUp clearfix" data-wow-delay="0.3s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
                <div className="row gx-2">
                    <div className="col-sm-12 text-center">
                        <h2 className="mb-4">
                            {data?.title} <span className="d-block text-primary"> {data?.subtitle}</span>
                            {/* <TypedText
                                    index={1}
                                    text={` <span  style="color: #000"> ${data?.title}</span> <span class="d-block" style="color: #2aa488"> ${data?.subtitle}</span>`}
                                    delay={100}
                                    cursor="|"
                                /> */}
                        </h2>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12" dangerouslySetInnerHTML={{ __html: data.description }} />
                    
                </div>
            </div>
            <div className="row g-4 mb-3">
                <div className="col-12" data-wow-delay="1s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
                    <div className="ci-offproj-swiper px-2">
                    <Swiper
                                  modules={[Navigation, Autoplay]}
                                                           navigation={false} // ✅ MUST ENABLE
                                                           loop={true}
                                                           autoplay={{ delay: 8000, disableOnInteraction: false }} // ✅ autoplay working
                                                           slidesPerView={1}
                                                           spaceBetween={20}
                                             
                                                           breakpoints={{
                                                             0: { slidesPerView: 1, slidesPerGroup: 1 },
                                                             768: { slidesPerView: 2, slidesPerGroup: 2 },
                                                             992: { slidesPerView: 3, slidesPerGroup: 3 },
                                                           }}
                                             
                                                           onSwiper={(swiper: any) => {
                                                             swiperRefs.current[0] = swiper;
                                             
                                                             setTimeout(() => {
                                                               const prevEl = prevRefs.current[0];
                                                               const nextEl = nextRefs.current[0];
                                             
                                                               if (!swiper || !swiper.params) return;
                                                               if (!prevEl || !nextEl) return;
                                             
                                                               // ✅ assign navigation safely
                                                               swiper.params.navigation.prevEl = prevEl;
                                                               swiper.params.navigation.nextEl = nextEl;
                                             
                                                               // ✅ re-init navigation
                                                               swiper.navigation.destroy();
                                                               swiper.navigation.init();
                                                               swiper.navigation.update();
                                                             }, 100);
                                                           }}
                                             
                                                           onSlideChange={(swiper: any) => updateCounter(swiper, 0)}
                                             
                        >
                            {filteredProjects?.map((slide:any) => (
                            <SwiperSlide key={slide.sliderid}>
                                <div className="service-item rounded-3 shadow-none overflow-hidden">
                                    <div className="service-image rounded-3">
                                        <img className="img-fluid "    src={slide.fileImg.url}  alt={slide.fileImg.alt || ""} loading="lazy" />
                                        <span className={`status-tag operational d-inline-flex align-items-center gap-1 ${slide?.project_tag === 'Operational' ? 'operational' : 'upcoming' }`}>
                                            {slide?.project_tag?.replace("Upcomming", "Upcoming") || " "}
                                        </span>
                                    </div>
                                    <div className="position-relative  mt-3   pt-0">
                                        <div className="mb-3">
                                                <small className="text-primary"> {slide?.project_type || " "}</small>
                                                <h5 className="mt-1">
                                                {slide?.title || " "}
                                                </h5>
                                        </div>

                                        <div className="row gx-2">
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                {slide?.project_category_list.map((cat :any,i:any) => (
                                                    <div className="position-relative" key={i}>
                                                        
                                                    <img src={slide.fileIcon.url || ""}
                                                        alt={slide.fileIcon.alt || ""}
                                                        className="position-absolute no-animation"
                                                        />
                                                        
                                                        <div className="ps-5" dangerouslySetInnerHTML={{ __html: cat?.value || '' }} />
                                                        
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            ))}
                            {/* Arrow + Counter */}
                            {totalGroups[0] > 1 && (
                      <div className="d-flex justify-content-center align-items-center gap-4 mt-4">
                        <span
                          ref={(el: any) => (prevRefs.current[0] = el)}
                          className="cursor-pointer swiper-arrow"
                        >
                          <i className="bi bi-arrow-left"></i>
                        </span>

                        <div className="fw-semibold">
                          {activeGroups[0] || 1} / {totalGroups[0] || 1}
                        </div>

                        <span
                          ref={(el: any) => (nextRefs.current[0] = el)}
                          className="cursor-pointer swiper-arrow"
                        >
                          <i className="bi bi-arrow-right"></i>
                        </span>
                      </div>
                    )}
                        </Swiper>
                    </div>
                </div>
            </div>
            <div className="text-center">
                <a href={data?.buttonLink[0]?.uri} className="btn btn-sm btn-primary rounded-pill">{data?.buttonLink[0]?.title}</a>
            </div>
        </div>
    </div>

    );
};

export default CIOffsiteProject;